<template>
  <div class="homePurchaseMaterial">
    <!-- <div
      v-if="carouselList[0]"
      class="adsBanner"
      :style="{ background: carouselList[0].background }"
    >
      <el-image :src="carouselList[0].url" fit="cover"></el-image>
    </div> -->
    <div v-if="carouselList[0]" class="carousel">
      <el-carousel :autoplay="true" :style="{ background: carouselList[0].background }">
        <el-carousel-item v-for="item of carouselList" :key="item.url">
          <el-image :src="item.url" fit="cover" @click="clickCarousel(item)"></el-image>
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="HomeContainer" style="margin-top: 15px">
      <template v-if="SearchData.quality_type == 1">
        <div class="nowFilter">
          <span style="width: 102px; text-indent: 12px">{{ l("当前筛选") }}：</span>
          <div v-if="SearchData.category_id" class="condition" @click="
            SearchData.category_id = null;
          GetTableList(true);
          ">
            {{ l("品类") }}:
            <span>{{ l($store.getCategoryName(SearchData.category_id)) }}</span>
            <i class="el-icon-close"></i>
          </div>
          <div v-if="SearchData.child_category" class="condition" @click="
            SearchData.child_category = '';
          GetTableList(true);
          ">
            {{ l("品名") }}:
            <span>{{ l(SearchData.child_category) }}</span>
            <i class="el-icon-close"></i>
          </div>

          <div v-if="SearchData.category_id || SearchData.child_category" class="clearAll" @click="
            SearchData.category_id = null;
          SearchData.child_category = '';
          GetTableList(true);
          ">
            {{ l("清除筛选") }}
          </div>
          <div v-else>{{ l("全部求购") }}</div>
        </div>
        <div class="categoryContainer">
          <div class="line">
            <div class="title">{{ l("品类") }}</div>
            <div class="category_list">
              <div v-for="category of $store.state.basicInfo.categoryList_purchase" :key="category.id"
                :class="{ active: SearchData.category_id == category.id }" @click="
                  SearchData.category_id = category.id;
                SearchData.child_category = '';
                GetTableList(true);
                ">
                {{ l(category.name) }}
              </div>
            </div>
          </div>
          <div class="line" v-if="child_categoryList.length">
            <div class="title">{{ l("品名") }}</div>
            <div class="category_list">
              <div v-for="child_category of child_categoryList" :key="child_category.id" :class="{
                active: SearchData.child_category == child_category.name,
              }" @click="
                  SearchData.child_category = child_category.name;
                GetTableList(true);
                ">
                {{ l(child_category.name) }}
              </div>
            </div>
          </div>
        </div>
      </template>
      <template v-if="SearchData.quality_type == 3">
        <div class="nowFilter">
          <span style="width: 102px; text-indent: 12px">{{ l("当前筛选") }}：</span>
          <div v-if="SearchData.forge_type" class="condition" @click="
            SearchData.forge_type = null;
          GetTableList(true);
          ">
            {{ l("类型") }}:
            <span>
              {{
                $utils.listFilter(
                  $store.state.basicInfo.forge_typeList,
                  SearchData.forge_type
                )
              }}
            </span>
            <i class="el-icon-close"></i>
          </div>

          <div v-if="SearchData.forge_type" class="clearAll" @click="
            SearchData.forge_type = null;
          GetTableList(true);
          ">
            {{ l("清除筛选") }}
          </div>
          <div v-else>{{ l("全部类型") }}</div>
        </div>
        <div class="categoryContainer">
          <div class="line">
            <div class="title">{{ l("类型") }}</div>
            <div class="category_list">
              <div v-for="forge_type of $store.state.basicInfo.forge_typeList" :key="forge_type.id"
                :class="{ active: SearchData.forge_type == forge_type.id }" @click="
                  SearchData.forge_type = forge_type.id;
                GetTableList(true);
                ">
                {{ forge_type.name }}
              </div>
            </div>
          </div>
        </div>
      </template>
      <template v-else-if="SearchData.quality_type == 4">
        <div class="nowFilter">
          <span style="width: 102px; text-indent: 12px">{{ l("当前筛选") }}：</span>
          <div v-if="SearchData.machining_type" class="condition" @click="
            SearchData.machining_type = null;
          GetTableList(true);
          ">
            {{ l("类型") }}:
            <span>
              {{
                $utils.listFilter(
                  $store.state.basicInfo.machining_typeList,
                  SearchData.machining_type
                )
              }}
            </span>
            <i class="el-icon-close"></i>
          </div>

          <div v-if="SearchData.machining_type" class="clearAll" @click="
            SearchData.machining_type = null;
          GetTableList(true);
          ">
            {{ l("清除筛选") }}
          </div>
          <div v-else>{{ l("全部类型") }}</div>
        </div>
        <div class="categoryContainer">
          <div class="line">
            <div class="title">{{ l("类型") }}</div>
            <div class="category_list">
              <div v-for="machining_type of $store.state.basicInfo.machining_typeList" :key="machining_type.id"
                :class="{ active: SearchData.machining_type == machining_type.id }" @click="
                  SearchData.machining_type = machining_type.id;
                GetTableList(true);
                ">
                {{ machining_type.name }}
              </div>
            </div>
          </div>
        </div>
      </template>
      <div class="orderContainer">
        <div class="orderItem" style="width: 84px" :class="{ active: !Sorting }" @click="
          Sorting = null;
        GetTableList(true);
        ">
          {{ l("综合") }}
        </div>
        <div class="orderItem" :class="{ active: Sorting == '-created_time' }" @click="
          Sorting = '-created_time';
        GetTableList(true);
        ">
          {{ l("最新发布") }}<i class="el-icon-top"></i>
        </div>
        <div class="orderItem" :class="{ active: Sorting == 'is_expire,expire_time' }" @click="
          Sorting = 'is_expire,expire_time';
        GetTableList(true);
        ">
          {{ l("即将截止") }}<i class="el-icon-top"></i>
        </div>



        <div class="filterItem">
          <div class="label">{{ l("国家/地区") }}</div>
          <el-select v-model="SearchData.country" :placeholder="l('请选择')"
            @change="SearchData.address = ''; GetTableList(true)" filterable clearable size="small">
            <el-option v-for="item in $store.state.basicInfo.countryList" :key="item.code"
              :label="item.cnName + ' (' + item.name + ')'" :value="item.code">
              <span style="float: left">{{ item.cnName }}（{{ item.name }}）</span>
              <span style="float: right">
                <img :src="GetResourceUrl('flags/' + item.code.toLowerCase() + '.png')" style="width:30px;" />
              </span>
            </el-option>
          </el-select>
        </div>


        <div v-show="SearchData.country == 'CN'" class="filterItem">
          <div class="label">{{ l("收货地") }}</div>
          <el-cascader ref="cascader" style="width: 220px" size="small" v-model="SearchData.address"
            :options="$store.state.basicInfo.cityList" :props="{
              expandTrigger: 'hover',
              label: 'name',
              value: 'name',
              children: 'child',
              emitPath: true,
              checkStrictly: true,
            }" :placeholder="l('请选择') + l('收货地')" filterable clearable @change="GetTableList(true)">
            <template slot-scope="{ node, data }">
              <div @click="cascaderClick(data)">
                <span>{{ data.name }}</span>
                <span v-if="false && !node.isLeaf">
                  ({{ data.child.length }})
                </span>
              </div>
            </template>
          </el-cascader>
        </div>

        <div v-if="$store.state.session.token" class="filterItem">
          <el-checkbox :label="l('我发布的')" v-model="SearchData.created_by_me" :true-label="1" :false-label="0"
            @change="GetTableList(true)"></el-checkbox>
        </div>

        <!-- <div class="filterItem">
          <el-checkbox
            label="仅显示可报价"
            v-model="SearchData.is_not_expire"
            true-label="true"
            false-label=""
            @change="GetTableList(true)"
          ></el-checkbox>
        </div> -->
      </div>

      <template v-if="TableList.length">
        <el-table :data="TableList" style="margin-top: 15px; box-shadow: none" @row-click="clickTable">
          <el-table-column prop="title" min-width="180" show-overflow-tooltip>
            <div slot="header" style="text-align: left !important; text-indent: 30px">
              {{ SearchData.quality_type == 1 ? l("品名 材质 规格") : l("标题") }}
            </div>
            <div slot-scope="scope" class="one_lines" style="text-align: left !important; text-indent: 30px">
              {{ scope.row.title }}
            </div>
          </el-table-column>

          <el-table-column v-if="SearchData.quality_type == 3" key="forge_type" :label="l('类型')" width="100">
            <template slot-scope="scope">
              {{
                $utils.listFilter(
                  $store.state.basicInfo.forge_typeList,
                  scope.row.forge_type
                )
              }}
            </template>
          </el-table-column>
          <el-table-column v-if="SearchData.quality_type == 4" key="machining_type" :label="l('类型')" width="100">
            <template slot-scope="scope">
              {{
                $utils.listFilter(
                  $store.state.basicInfo.machining_typeList,
                  scope.row.machining_type
                )
              }}
            </template>
          </el-table-column>
          <!-- <el-table-column
            v-if="SearchData.quality_type == 3"
            key="img_array"
            label="图纸"
            width="120"
          >
            <template slot-scope="scope">
              <el-image
                v-if="scope.row.img_array[0]"
                style="height: 40px; width: 100%"
                :src="scope.row.img_array[0]"
                fit="contain"
              ></el-image>
            </template>
          </el-table-column> -->

          <el-table-column v-if="SearchData.quality_type == 1 || SearchData.quality_type == 2" :label="l('钢厂')"
            width="130" show-overflow-tooltip>
            <template slot-scope="scope">
              {{ l(scope.row.steel_mill) }}
            </template>
          </el-table-column>
          <el-table-column :label="l('采购量')" min-width="100" show-overflow-tooltip>
            <template slot-scope="scope">
              {{ scope.row.specification_amount[0].amount }}
              {{ l(scope.row.specification_amount[0].unit) }}
            </template>
          </el-table-column>

          <el-table-column :label="l('国家/地区')" min-width="100" show-overflow-tooltip>
            <template slot-scope="scope">
              <img :src="GetResourceUrl('flags/' + scope.row.country.toLowerCase() + '.png')"
                style="width:20px;vertical-align: middle;" />
            </template>
          </el-table-column>

          <el-table-column prop="address" :label="l('收货地')" width="150" show-overflow-tooltip></el-table-column>

          <el-table-column key="auth_count" :label="l('报价情况')" width="140">
            <template slot-scope="scope">
              <!-- <span v-if="scope.row.auth_count" class="ViewLink" @click.stop="showBusiness(scope.row)"
                >{{ scope.row.auth_count }}{{l("家已报价")}}</span
              >
              <span v-else style="color: #999">{{l("暂无报价")}}</span> -->
              <span v-if="scope.row.is_expire" style="color: #999">{{ l("已截止") }}</span>
              <span v-else class="color-warning">{{ l("可报价") }}</span>
            </template>
          </el-table-column>

          <el-table-column :label="l('发布日期')" width="130">
            <template slot-scope="scope">
              {{ scope.row.created_time.slice(0, 10) }}
            </template>
          </el-table-column>

          <el-table-column :label="l('截止日期')" width="130">
            <template slot-scope="scope">
              {{ scope.row.expire_time.slice(0, 10) }}
            </template>
          </el-table-column>

          <el-table-column :label="l('操作')" width="140">
            <!-- <template slot-scope="scope">
              <span v-if="scope.row.is_expire" style="color: #999"
                >{{l("报价已截止")}}</span
              >
              <div v-else class="goDetailBtn" target="_blank">{{l("我要报价")}}</div>
            </template> -->
            <div class="goDetailBtn" target="_blank">{{ l("查看详情") }}</div>
          </el-table-column>
        </el-table>

        <el-pagination style="justify-content: center; margin-top: 35px" background
          @current-change="HandleCurrentChange" :current-page="CurrentPage" :page-size="PageSize"
          layout="total, prev, pager, next, jumper" :total="TotalCount"></el-pagination>
      </template>
      <el-empty v-else :description="l('抱歉，没有找到你要搜索的求购，试试发布商品信息吧。')">
      </el-empty>
    </div>

    <!-- <el-dialog :title="l('报价记录')" :visible.sync="businessDialogVisible" :destroy-on-close="true" width="1200px">
      <BusinessList v-if="businessDialogVisible" :api_url="business_api_url" :manager_caigouList="manager_caigouList"
        :nowShowBusinessRow="nowShowBusinessRow"/>
      <span slot="footer" class="dialog-footer">
        <el-button @click="businessDialogVisible = false">{{
          l("取 消")
        }}</el-button>
      </span>
    </el-dialog> -->
  </div>
</template>

<script>
import tableMixin from "@/assets/js/tableMixin";
// import BusinessList from "@/components/common/BusinessList.vue";

export default {
  name: "HomePurchase",
  mixins: [tableMixin],
  components: {
    // BusinessList,
  },
  data() {
    return {
      PageSize: 20,
      SearchData: {
        quality_type: null,
        forge_type: null,
        machining_type: null,
        title: this.$store.state.headerFilter,
        category_id: null,
        child_category: "",
        address: [],
        is_not_expire: "",
        country: "",
        created_by_me: 0
      },
      carouselList: [],


      business_api_url: "",
      // businessDialogVisible: false,

      // manager_caigouList: [],
      // nowShowBusinessRow: null,//目前正在展示BusinessList的row
    };
  },
  computed: {
    child_categoryList() {
      var category = this.$store.state.basicInfo.categoryList.find(
        (item) => item.id == this.SearchData.category_id
      );
      if (category) {
        return category.child;
      } else {
        return [];
      }
    },
  },
  watch: {},
  created() {
    if (this.$route.name == "home_purchase_material") {
      this.SearchData.quality_type = 1;
    } else if (this.$route.name == "home_purchase_piece") {
      this.SearchData.quality_type = 2;
    } else if (this.$route.name == "home_purchase_forging") {
      this.SearchData.quality_type = 3;
    }else if (this.$route.name == "home_purchase_machining") {
      this.SearchData.quality_type = 4;
    }


    if (this.$route.query.forge_type) {
      this.SearchData.forge_type = this.$route.query.forge_type;
    }
    this.getCarousel();

    // if (this.$store.getters.checkRoleList([3001, 3002, 30051])) {
    //   this.axios
    //     .get("/api/admin_user/backend_user_simple_list/", {
    //       params: {
    //         role: "3005,30051"
    //       },
    //     })
    //     .then((data) => {
    //       this.manager_caigouList = data;
    //     });
    // }

  },
  mounted() {
    this.$EventBus.$on("headerSearch", ({ filterText }) => {
      this.SearchData.title = filterText;
      this.GetTableList(true);
    });
  },
  beforeDestroy() {
    this.$EventBus.$off("headerSearch");
  },
  methods: {
    GetTableList(resetPage) {
      if (resetPage == true) this.CurrentPage = 1;

      this.axios
        .get("/api/visitor_purchase/", {
          params: {
            ...this.SearchData,
            ordering: this.Sorting,
            size: this.PageSize,
            page: this.CurrentPage,
          },
        })
        .then((data) => {
          this.TotalCount = data.count;
          this.TableList = data.results.map((item) => {
            try {
              item.img_array = JSON.parse(item.img_array);
            } catch (e) {
              console.error(e);
            }
            return item;
          });
        });
    },
    getCarousel() {
      let position = "";
      if (this.SearchData.quality_type == 1) {
        position = "carousel_purchase_material";
      } else if (this.SearchData.quality_type == 2) {
        position = "carousel_purchase_piece";
      } else if (this.SearchData.quality_type == 3) {
        position = "carousel_purchase_forging";
      } else if (this.SearchData.quality_type == 4) {
        position = "carousel_purchase_machining";
      }
      this.axios
        .get("/api/banner/", {
          params: {
            position,
            show_pc: true,
            is_show: true,
            i18n: this.$store.state.lang == 'zh-CN' ? false : true,
          },
        })
        .then((data) => {
          this.carouselList = data;
        });
    },
    clickCarousel(item) {
      if (item.path_pc) {
        if (item.path_pc.indexOf("http") == 0) {
          window.open(item.path_pc);
        } else {
          this.$router.push({ path: item.path_pc });
        }
      }
    },
    clickTable(row) {
      if (this.SearchData.quality_type == 1) {
        this.$openRouter({
          path: `/home/purchase_material/${row.code}`,
        });
      } else if (this.SearchData.quality_type == 2) {
        this.$openRouter({
          path: `/home/purchase_piece/${row.code}`,
        });
      } else if (this.SearchData.quality_type == 3) {
        this.$openRouter({
          path: `/home/purchase_forging/${row.code}`,
        });
      } else if (this.SearchData.quality_type == 4) {
        this.$openRouter({
          path: `/home/purchase_machining/${row.code}`,
        });
      }
    },
    cascaderClick(nodeData) {
      this.addrCode = nodeData.name;
      this.$refs.cascader.checkedValue = nodeData.name;
      this.$refs.cascader.computePresentText();
      this.$refs.cascader.toggleDropDownVisible(false);
    },

    // showBusiness(item) {
    //   this.nowShowBusinessRow = item;

    //   // //管理员
    //   // if (this.$store.getters.checkRole(3001) || this.$store.getters.checkRole(3002)) {
    //   //   this.business_api_url = `/api/admin_purchase/${item.code}/business_list/`;
    //   // }
    //   // //市场部
    //   // else if (this.$store.getters.checkRole(3004) || this.$store.getters.checkRole(30041)) {
    //   //   this.business_api_url = `/api/visitor_purchase/${item.code}/salesman_business_list/`;
    //   // }
    //   // //采购部leader
    //   // else if (this.$store.getters.checkRole(30051)) {
    //   //   this.business_api_url = `/api/visitor_purchase/${item.code}/salesman_business_list/`;
    //   // }
    //   // //普通采购部、游客、普通用户
    //   // else {//||this.$store.getters.checkRole(3005)||this.$store.getters.checkRole(30051)
    //   //   this.business_api_url = `/api/visitor_purchase/${item.code}/business_list/`;
    //   // }
    //   this.business_api_url = `/api/visitor_purchase/${item.code}/business_list/`;
    //   this.businessDialogVisible = true;
    // },
  },
};
</script>


<style scoped lang="scss">
// .adsBanner {
//   width: 100%;
//   height: 190px;
//   position: relative;
//   overflow: hidden;
//   .el-image {
//     width: 1920px;
//     height: 190px;
//     position: absolute;
//     left: 50%;
//     top: 0;
//     transform: translateX(-50%);
//   }
// }

.carousel {
  max-width: 1920px;
  margin: 0 auto;
  width: 100%;
  height: 190px;
  position: relative;

  .el-carousel {
    width: 100%;
    height: 100%;

    /deep/.el-carousel__container {
      height: 100%;

      .el-carousel__item {
        height: 100%;
      }

      .el-carousel__item .el-image {
        height: 100%;
        width: 100%;
      }
    }
  }
}

.nowFilter {
  display: flex;
  font-size: 14px;
  line-height: 24px;
  height: 24px;
  padding: 12px 0;
  color: #666;
  background: #fff;

  .condition {
    box-sizing: border-box;
    border: 1px solid $borderColor;
    padding: 0 6px;
    margin-right: 15px;
    cursor: pointer;

    &:hover {
      border-color: $warningColor;

      i {
        color: $warningColor;
      }
    }

    span {
      color: $warningColor;
    }

    i {
      cursor: pointer;
    }
  }

  .clearAll {
    margin-left: 20px;
    color: $warningColor;
    cursor: pointer;
  }
}

.categoryContainer {
  box-sizing: border-box;
  background: #fff;

  .line {
    display: flex;
    line-height: 42px;
    border-top: 1px solid $borderPlainColor;

    .title {
      background: #f5f5f5;
      width: 84px;
      color: #333;
      text-align: center;
    }

    .category_list {
      display: flex;

      div {
        margin-left: 30px;
        cursor: pointer;

        &:hover {
          color: $warningColor;
        }

        &.active {
          color: $warningColor;
        }
      }
    }
  }
}

.orderContainer {
  margin-top: 12px;
  display: flex;
  line-height: 45px;
  text-align: center;
  border: 1px solid $borderPlainColor;
  box-sizing: border-box;
  background: #fff;

  .orderItem {
    box-sizing: border-box;
    padding: 0 18px;
    border-right: 1px solid $borderPlainColor;
    cursor: pointer;

    &.active {
      color: $warningColor;
    }
  }

  .filterItem {
    padding: 0 20px;
    display: flex;
    align-items: center;

    // border-right: 1px solid $borderPlainColor;
    .label {
      margin-right: 10px;
    }

    // .el-select, .el-cascader{
    //   width: 150px !important;
    // }
  }
}

.goDetailBtn {
  border: 1px solid $warningColor;
  color: $warningColor;
  width: 82px;
  height: 28px;
  line-height: 28px;
  text-align: center;
  cursor: pointer;
  margin: 0 auto;

  &:hover {
    color: #fff;
    background: $warningColor;
  }
}

/deep/.el-table__row {
  height: 68px;
}

/deep/.el-empty {
  background: #fff;
}
</style>
